import { useEffect } from "react";
import { applyTheme } from "./themeUtils";

const pricingPlans = [
  {
    name: "Standard",
    price: "99",
    subtitle: "For smaller events",
    limit: "10 files / person",
    validity: "30 days",
    ideal: "Baptisms, birthdays, intimate gatherings",
    featured: false,
  },
  {
    name: "Plus",
    price: "179",
    subtitle: "Most popular choice",
    limit: "20 files / person",
    validity: "60 days",
    ideal: "Weddings and parties with 100–350 guests",
    featured: true,
  },
  {
    name: "Pro / Unlimited",
    price: "279",
    subtitle: "For larger events",
    limit: "Unlimited or 40 files / person",
    validity: "180 days",
    ideal: "Large weddings, events with 400+ guests",
    featured: false,
  },
];

const upsells = [
  "Visual page personalization (+49 RON)",
  "Printable QR table kit (+39 RON)",
  "Extended storage validity (+29 RON / 3 months)",
  "VIP package bundle (+79 RON) – includes full visual personalization, QR table kit, and 90 extra days of storage",
];

export default function PricingPage() {
  useEffect(() => {
    applyTheme("ivoryGold");
  }, []);

  return (
    <div className="event-index-page">
      <section className="event-hero" style={{ paddingBottom: 64 }}>
        <div className="event-hero-glow" />
        <div className="container event-hero-inner">
          <div className="row align-items-center g-5">
            <div className="col-lg-8 mx-auto text-center">
              <div className="event-badge">Simple pricing</div>
              <h1 className="event-hero-title" style={{ maxWidth: "100%" }}>
                Choose the package that fits your event.
              </h1>
              <p className="event-hero-copy" style={{ maxWidth: "720px", margin: "22px auto 0" }}>
                Every plan includes the essential service: standard QR generation, photo and video uploads, private organizer gallery, and full ZIP archive download.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="event-pricing-section" style={{ paddingTop: 10 }}>
        <div className="container">
          <div className="event-pricing-grid">
            {pricingPlans.map((plan) => (
              <div
                key={plan.name}
                className={`event-plan-card ${plan.featured ? "featured" : ""}`}
              >
                {plan.featured && <div className="event-plan-badge">Recommended</div>}
                <div className="event-plan-header">
                  <span className="event-plan-name">{plan.name}</span>
                  <span className="event-plan-subtitle">{plan.subtitle}</span>
                </div>

                <div className="event-plan-price-row">
                  <span className="event-plan-price">{plan.price}</span>
                  <span className="event-plan-currency">RON</span>
                </div>

                <ul className="event-plan-list">
                  <li><strong>Upload limit:</strong> {plan.limit}</li>
                  <li><strong>Archive validity:</strong> {plan.validity}</li>
                  <li><strong>Includes:</strong> QR code, private gallery, photo & video upload, full ZIP download</li>
                  <li><strong>Ideal for:</strong> {plan.ideal}</li>
                </ul>

                <button type="button" className="event-plan-button">
                  Add to cart
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="event-upsell-section">
        <div className="container">
          <div className="event-section-heading center">
            <span className="event-kicker">Optional add-ons</span>
            <h2>Choose what you want to add.</h2>
          </div>

          <div className="event-upsell-panel">
            <div className="event-upsell-header">
              <span>Extra options</span>
            </div>
            <div className="event-upsell-list">
              {upsells.map((item) => (
                <label key={item} className="event-upsell-item">
                  <input type="checkbox" readOnly checked />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="event-cta-section">
        <div className="container event-cta-box">
          <div>
            <span className="event-kicker light">Ready to begin</span>
            <h2>Create a more memorable event experience.</h2>
          </div>
          <a href="/" className="event-primary-btn dark">
            Back to home
          </a>
        </div>
      </section>

      <footer className="event-footer">
        <div className="container">
          <span>Powered by EventSnap</span>
        </div>
      </footer>
    </div>
  );
}
